import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import Decimal from "decimal.js"
import _ from "lodash"
import { useCallback, useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import EmptyTextHeader from "../../../components/FlexGridWrapper/EmptyTextHeader"
import CONSTANT from "../../../constant"
import { RootState } from "../../../globalStore/rootreducer"
import {
  T部所別車輌台数,
  T配車件数,
} from "../../../service/dashboard/TDashboard"

/**
 * 配車件数表示用グリッド
 * 選択された部所コードが運行部所である配車の件数を表示
 * @param props
 * @returns
 */
export const HaisyaKensuGrid: React.FC<{
  haisyaKensu: T配車件数[] | null | undefined
  syaryoCount: T部所別車輌台数[] | null | undefined
  businessDay: number
  busyoCode: string | null | undefined
}> = (props) => {
  const gridRef = useRef<wjrGrid.FlexGrid>(null)
  const 営業日 = useSelector((state: RootState) => dayjs(state.date.eigyobiStr))

  const [稼働率, set稼働率] = useState<number>()
  const createGridRow = useCallback(
    (配車件数List: T配車件数[], 項目名: "自部所" | "他部所" | "合計") => {
      const dayjs営業日 = dayjs(営業日)
      const 今日 = _.sumBy(
        配車件数List.filter((i) => dayjs(i.配車日).isSame(dayjs営業日)),
        "配車件数"
      )
      const 今月 = _.sumBy(配車件数List, "配車件数")

      return {
        項目名,
        今月,
        今日,
        稼働率: 0,
      }
    },
    [営業日]
  )

  useEffect(() => {
    if (
      gridRef == null ||
      gridRef.current == null ||
      gridRef.current.control == null ||
      props.haisyaKensu == null ||
      props.syaryoCount == null
    )
      return
    const grid = gridRef.current.control as wjcGrid.FlexGrid

    // 表示用に加工
    const 部所会社別車輌台数 = props.syaryoCount.filter(
      (s) =>
        (wjcCore.isNullOrWhiteSpace(props.busyoCode ?? "")
          ? true
          : s.所属部所コード === props.busyoCode) && s.原動機有無フラグ === 1
    )

    const 部所配車件数 = props.haisyaKensu.filter((h) =>
      wjcCore.isNullOrWhiteSpace(props.busyoCode ?? "")
        ? true
        : h.運行部所コード === props.busyoCode
    )

    const 自部所 = createGridRow(
      部所配車件数.filter((h) => h.受注部所コード === h.運行部所コード),
      "自部所"
    )

    const 他部所 = createGridRow(
      部所配車件数.filter((h) => h.受注部所コード !== h.運行部所コード),
      "他部所"
    )

    const 合計 = createGridRow(部所配車件数, "合計")

    // 稼働率計算も行う
    // 当月の合計配車件数 / (自部所の車輌台数 * 営業日数)
    const 車輌台数 = _.sumBy(部所会社別車輌台数, "車輌台数")
    const 総稼働数 = new Decimal(車輌台数).times(props.businessDay)
    const Dec稼働率 =
      車輌台数 !== 0 ? new Decimal(合計.今月).div(総稼働数) : new Decimal(1)

    set稼働率(Dec稼働率.isNaN() ? 0 : Dec稼働率.toNumber())

    grid.itemsSource = [自部所, 他部所, 合計]
  }, [
    createGridRow,
    props.haisyaKensu,
    props.syaryoCount,
    props.businessDay,
    props.busyoCode,
  ])

  return (
    <table className="w-100">
      <tbody>
        <tr>
          <td className="w-25rem align-top">
            <wjrGrid.FlexGrid
              className="w-19rem max-h-7.5rem"
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              ref={gridRef}>
              <wjrGrid.FlexGridColumn
                width={80}
                cssClassAll={"wj-header important-background"}
                binding={"項目名"}>
                <EmptyTextHeader></EmptyTextHeader>
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                binding={"今日"}
                header={"今日"}></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={"*"}
                binding={"今月"}
                header={"今月"}></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
          </td>
          <td className="text-center align-top">
            <div className="w-10rem">
              <div
                style={{
                  padding: "2rem 1rem",
                  border: "1px solid rgba(0,0,0,.2)",
                  fontSize: "2rem",
                }}>
                {稼働率 && `${wjcCore.Globalize.formatNumber(稼働率, "p2")}`}
              </div>
              <div
                style={{
                  paddingTop: "0.2rem",
                  backgroundColor: "rgb(0, 153, 153)",
                  color: "rgb(255, 255, 255)",
                  border: "1px solid rgba(0,0,0,.2)",
                  fontSize: "1.2rem",
                }}>
                稼働率
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
